import React, { useState } from "react";

import Container from "react-bootstrap/Container";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

import { Navigate } from "react-router-dom";

import CadastroComOrg from "../components/Cadastro/CadastroComOrg";
import CadastroSemOrg from "../components/Cadastro/CadastroSemOrg";

const Cadastro = () => {
	const [ehAdmin, setEhAdmin] = useState(false);
	const [isFetching, setIsFetching] = useState(true);

	const centerViewPort = {
		margin: "0 auto",
		position: " absolute",
		left: "50%",
		top: "50%",
	};

	return (
		<>
			{isFetching ? (
				<Container>
					<h1 className="m-5">Cadastre-se</h1>

					<div>
						<div className="">
							<div className="text-center">
								Informe o <b>e-mail</b> cadastrado pelo
								Administrador.
								<br />
								Se você ainda não tem seu e-mail cadastrado,
								entre em contato com o Administrador
								(nit@univasf.edu.br) e obtenha as informações
								necessárias.
							</div>
						</div>
					</div>

					<div className="d-flex justify-content-start mt-5">
						<Button
							onClick={() => setEhAdmin((prev) => !prev)}
							// variant={!ehAdmin ? "contained" : "outlined"}
							variant="outlined"
							size="small"
						>
							{ehAdmin ? "Usuário?" : "Admin?"}
						</Button>
					</div>

					{ehAdmin ? (
						<CadastroSemOrg setIsFetching={setIsFetching} />
					) : (
						<CadastroComOrg setIsFetching={setIsFetching} />
					)}
				</Container>
			) : (
				<div
					style={centerViewPort}
					className="d-flex justify-content-center"
				>
					<CircularProgress />
					<Navigate to="/login" />
				</div>
			)}
		</>
	);
};

export default Cadastro;
